(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EditOrderBagV2Controller', EditOrderBagV2Controller);

    EditOrderBagV2Controller.$inject = ['$rootScope', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSessionCustom', 'CustomerCustom', '$translate', 'invoiceInfoEntity', 'OrderBagCustom', '$uibModal', 'OrderBagServiceItemCustom', 'InvoiceInfoCustom', 'ScheduleInfoCustom', 'CompanyInfoQuery', '$window', 'DEFAULT_VIDEO_CALL_URL', 'DialogService', '$mdDialog', '$state', 'PaymentLogCustom', 'PaymentLog', 'CompanyCustomerCustom', 'Principal', 'Servant', '$mdBottomSheet', 'DateUtils', '$resource', 'ENV', '$mdMedia'];

    function EditOrderBagV2Controller($rootScope, $timeout, $scope, entity, $stateParams, OrderBag, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSessionCustom, CustomerCustom, $translate, invoiceInfoEntity, OrderBagCustom, $uibModal, OrderBagServiceItemCustom, InvoiceInfoCustom, ScheduleInfoCustom, CompanyInfoQuery, $window, DEFAULT_VIDEO_CALL_URL, DialogService, $mdDialog, $state, PaymentLogCustom, PaymentLog, CompanyCustomerCustom, Principal, Servant, $mdBottomSheet, DateUtils, $resource, ENV, $mdMedia) {
        var vm = this;

        vm.orderBag = entity;

        // })
        vm.invoiceInfo = invoiceInfoEntity;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.findBalanceStyle = findBalanceStyle;

        vm.clear = clear;
        vm.save = save;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.hasParticipant = hasParticipant;
        vm.approveOrderBag = approveOrderBag;
        vm.cancelOrderBag = cancelOrderBag;
        vm.isBalanced = isBalanced;
        vm.constStatus = {};
        vm.constStatus.confirmed = 1;
        vm.constStatus.canceled = 4;
        vm.constStatus.reserveRequest = 5;
        vm.constStatus.requestConfirm = 6;
        vm.timeDiff = timeDiff;
        //vm.checkin = checkin;
        //vm.removeCheckIn = removeCheckIn;
        vm.removeCheckinOrderBagServieItem = removeCheckinOrderBagServieItem;
        vm.checkinOrderBagServieItem = checkinOrderBagServieItem;
        vm.notCheckinOrderBagServieItem = notCheckinOrderBagServieItem;
        vm.replaceTime = replaceTime;
        vm.insertPayment = insertPayment;
        vm.confirmReserveRequest = confirmReserveRequest;
        vm.showTimePeriod = showTimePeriod;
        vm.showReplaceTime = true;
        vm.goToVideoCall = goToVideoCall;
        vm.deleteOrderBagItem = deleteOrderBagItem;
        vm.canDeleteItem = false;
        vm.settlementInvoice = settlementInvoice;
        vm.deletePaymentLog = deletePaymentLog;
        vm.openMenu = openMenu;
        vm.originatorEv = null;
        vm.canReApproveRequestToPay = false;
        vm.canResendNotification = false;
        vm.reConfirmReserveRequest = reConfirmReserveRequest;
        vm.reSendNotification = reSendNotification;
        vm.goToCustomerDetail = goToCustomerDetail;
        vm.companyCustomer = null;
        vm.canDeleteOrderBag = false;
        vm.issueInvoiceInfo = issueInvoiceInfo;
        vm.findInvoiceStatusStyle = findInvoiceStatusStyle;
        vm.canEditPaymentLog = canEditPaymentLog;
        vm.viewInvoiceInfo = viewInvoiceInfo;
        vm.showWithdrawFromWalletModal = showWithdrawFromWalletModal;
        vm.showPosPayment = showPosPayment;

        vm.closeModal = closeModal;

        vm.openBottomSheet = openBottomSheet;
        vm.deleteOrderBag = deleteOrderBag;
        vm.hasInvoiceFeature = false;
        vm.showPriceTitle = false;

        // tags
        vm.metaTags = []
        vm.defaultTags = []
        vm.tags = []

        vm.newTag = null

        vm.saveTagsLoading = false
        vm.getTagsLoading = false
        vm.insertTag = insertTag
        vm.deleteTag = deleteTag
        vm.resetTag = resetTag
        vm.resetTag = resetTag
        vm.gotToTags = gotToTags
        vm.selectedTagChanged = selectedTagChanged
        vm.managerApprovalStatus = ""

        function getMetaTags() {

            var resourceUrl = ENV.API_BASE_URL + "api/v2/order-bags/meta-tags";

            $resource(resourceUrl, {}, {'query': {method: 'GET', isArray: true}}).query(function (data) {
                vm.metaTags = data
            })

        }

        function getOrderBagTags() {
            var resourceUrl = ENV.API_BASE_URL + "api/v2/order-bags/" + $stateParams.id + "/tags";

            $resource(resourceUrl, {}, {'query': {method: 'GET', isArray: true}}).query(function (data) {
                vm.tags = JSON.parse(JSON.stringify(data))
                vm.defaultTags = JSON.parse(JSON.stringify(data))
                vm.getTagsLoading = false
            })

        }


        getOrderBagTags()
        getMetaTags()


        function insertTag(tag) {

            if (vm.saveTagsLoading) return null
            vm.saveTagsLoading = true

            var saveTagsService = function () {
                var resourceUrl = ENV.API_BASE_URL + "api/v2/order-bags/" + $stateParams.id + "/tags"
                return $resource(resourceUrl, {}, {
                        update: {method: "PUT", isArray: true},

                    }
                );
            }

            var body = vm.tags.map(function (item) {
                return item.id
            })


            function onSaveSuccessTag(response) {
                vm.tags = response
                vm.defaultTags = response
                vm.newTag = ""
                vm.saveTagsLoading = false
            }

            function onSaveError() {
                vm.saveTagsLoading = false

            }


            saveTagsService().update(body, onSaveSuccessTag, onSaveError);


        }


        function deleteTag(index, tag) {
            vm.tags.splice(index, 1)
        }

        function resetTag() {
            vm.tags = JSON.parse(JSON.stringify(vm.defaultTags))
        }

        function gotToTags(id) {
            document.querySelector(id).scrollIntoView();
        }

        function selectedTagChanged(selectedItem) {
            if (vm.tags.find(function (item) {
                return item.id === vm.newTag.id
            })) return vm.newTag = null
            vm.tags.push(vm.newTag)
            vm.newTag = null
        }

        //

        $rootScope.$broadcast('hideNavBar');

        load();
        canEditOrderBag();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        $scope.$watch('vm.orderBag.orderBagServiceItems', function (ob) {

            if (ob != null) {
                if (ob != null && ob != undefined && ob.length > 0) {
                    canReplaceTime(ob[0].serviceItem.id);
                }
            }
        })

        $scope.$watch('vm.orderBag.status', function (s) {

            if (s != null) {
                checkOtherActions();
            }
        })


        function load() {
            hasInvoiceFeature();
            hasAdvancedPricingFeature();
        }

        function hasInvoiceFeature() {
            var result;

            result = Principal.hasSpecialFeatureAccess("invoice");
            if (result) {
                vm.hasInvoiceFeature = true;
                return;
            } else {
                vm.hasInvoiceFeature = false;
            }


        }

        function hasAdvancedPricingFeature() {
            var result;

            result = Principal.hasSpecialFeatureAccess("advancedPricing");
            if (result) {
                vm.showPriceTitle = true;
                return;
            }

            vm.showPriceTitle = false;
        }

        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }


        function save() {

            vm.isSaving = true;
            if (vm.orderBag.id !== null) {
                OrderBag.update(vm.orderBag, onSaveSuccess, onSaveError);
            } else {
                OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findStatusTitle(status) {
            var result = "";

            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-box-" + status;
        }

        function findInvoiceStatusStyle(status) {
            return "invoice-info-status-box invoice-status-" + status;
        }

        function hasParticipant() {
            var hasPP = false;

            angular.forEach(vm.orderBag.orderBagServiceItems, function (v) {
                angular.forEach(v.participantPersons, function (p) {
                    hasPP = true;
                });
            });


            return hasPP;
        }

        function approveOrderBag() {

            if (vm.orderBag.id != null)
                OrderBagCustom.approveReserve().save(vm.orderBag.id, onApproveSucces, onApproveError);
            //OrderBagCustom.approveOrderBag().save(vm.orderBag.id, onApproveSucces, onApproveError);
        }

        function onApproveSucces(result) {

            reload();
        }

        function onApproveError() {

        }

        function cancelOrderBag() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("آیا از لغو اطمینان دارید ؟").then(function () {
                    OrderBagCustom.cancelReserve().save(vm.orderBag.id, onCancelSucces, onCancelError);

                });
            }
        }

        function onCancelSucces(result) {

            reload();
        }

        function onCancelError() {

        }

        function deleteOrderBag() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("آیا از حذف اطمینان دارید ؟").then(function () {
                    OrderBagCustom.deleteReserve().save(vm.orderBag.id, onDeleteSuccess, onDeleteError);

                });
            }
        }

        function onDeleteSuccess(result) {
            closeModal();
        }

        function onDeleteError() {

        }
        function reload() {
            OrderBagCustom.getOrderBagWithEntities($stateParams.id).query(function (data) {
                vm.orderBag = data;
            });
            InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query(function (data) {
                vm.invoiceInfo = data;
            });
            // getOrderBagTags();
            canEditOrderBag();

        }

        //function checkin()
        //{
        //
        //    if(vm.orderBag.id!=null )
        //    {
        //        OrderBagCustom.checkin().save(vm.orderBag.id,onCancelSucces,onCancelError);
        //    }
        //}

        function checkinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.checkinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function notCheckinOrderBagServieItem(orderBagServiceItemId) {

            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.notCheckinOrderBagServieItem().save(orderBagServiceItemId, onCancelSucces, onCancelError);
            }
        }

        function canEditOrderBag() {
            OrderBagCustom.canEditOrderBag($stateParams.id).query(function (data) {
                vm.resultStatus = data;
            });

        }

        //function removeCheckIn()
        //{
        //    if(vm.orderBag.id!=null ) {
        //        OrderBagCustom.removeCheckin().save(vm.orderBag.id,onSuccess,onError);
        //    }
        //}
        function removeCheckinOrderBagServieItem(orderBagServiceItemId) {
            if (orderBagServiceItemId != null) {
                OrderBagServiceItemCustom.removeCheckinOrderBagServieItem().save(orderBagServiceItemId, onSuccess, onError);
            }
        }

        function onSuccess() {
            reload();
        }

        function onError() {

        }

        function isBalanced() {
            return (vm.orderBag.remainAmount == 0);

        }

        function findBalanceStyle() {
            if (vm.orderBag.remainAmount == 0) {
                return "panel-success";
            } else {
                return "panel-danger";
            }
        }

        function replaceTime(orderBagItem) {

            // $mdDialog.show({
            //     templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
            //     controller: 'EditOrderBagServiceItemComponentController',
            //     controllerAs: '$ctrl',
            //     backdrop: 'static',
            //     size: 'lg',
            //     resolve: {
            //         entity: function () {
            //             return {
            //                 orderBagItem: orderBagItem
            //             };
            //
            //         }
            //     },
            //     clickOutsideToClose: true
            // }).then(function (v) {
            //
            //     if(v)
            //     {
            //         orderBagItem.serviceTimeSession = v.serviceTimeSession;
            //         Servant.get({id : v.servant.id}).$promise.then(function (result) {
            //             orderBagItem.servant = result;
            //         });
            //         canEditOrderBag();
            //     }
            //
            // }, function () {
            //     //nothing
            // });
            //


            $uibModal.open({
                templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item-v2.html',
                controller: 'EditOrderBagServiceItemComponentController',
                controllerAs: '$ctrl',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: function () {
                        return {
                            orderBagItem: orderBagItem
                        };

                    }
                },
                clickOutsideToClose: true
            }).result.then(function (v) {

                if (v) {
                    orderBagItem.serviceTimeSession = v.serviceTimeSession;
                    Servant.get({id: v.servant.id}).$promise.then(function (result) {
                        orderBagItem.servant = result;
                    });
                    canEditOrderBag();
                }
                //reload();
                // $uibModalInstance.close(result);
            }, function () {
                //nothing
                // $uibModalInstance.close(result);
            });

        }

        function insertPayment() {
            $uibModal.open({
                templateUrl: 'app/entities/payment-log/order-bag-payment-log-dialog-v2.html',
                controller: 'OrderBagPaymentLogDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            traceCode: null,
                            paymentType: null,
                            createDate: null,
                            id: null,
                            orderBagId: $stateParams.id
                        };
                    }]
                }
            }).result.then(function (v) {

                vm.invoiceInfo.paymentLogs.push({
                    id: v.id,
                    traceCode: v.traceCode,
                    paymentType: v.paymentType,
                    createDate: v.createDate,
                    amount: v.amount,
                    moreInfo: v.moreInfo
                });

                vm.orderBag.remainAmount -= v.amount;
                //reload();
            }, function () {
                //nothing
            });
        }

        function confirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.confirmReserveRequestByOrderBagId().save(vm.orderBag.id, onConfirmReserveSuccess, onConfirmReserveError);

                });
            }
        }

        function onConfirmReserveSuccess(result) {

            reload();
        }

        function onConfirmReserveError() {

        }

        function timeDiff(orderBagItem) {

            var d1 = new Date(orderBagItem.serviceTimeSession.endTime);
            var d2 = new Date(orderBagItem.serviceTimeSession.startTime);
            var min = 1000 * 60;
            //orderBagItem.timePeriod = (d1 - d2) / min;
            orderBagItem.timePeriod = 60;
        }

        function showTimePeriod(orderBagItemDtail, orderBagItem) {
            if (orderBagItem.startDate == orderBagItem.endDate && orderBagItemDtail.timeUnitQty > 1)
                return true;

            return false;

        }

        function canReplaceTime(serviceItemId) {

            // ScheduleInfoCustom.getCurrentScheduleInfoByServiceItem(serviceItemId).query().$promise.then(function (result) {
            //
            //     if (result.scheduleType == 'FLOAT_TIME_SESSIONS')
            //         vm.showReplaceTime = false;
            // })

            // var canReplaceTime = false;
            // //check servant is in serviceSeravnt list
            // ServiceItemCustom.getServiceServants(vm.orderBagServiceItem.serviceItemId).query(function (servants) {
            //     var servantid =  vm.orderBagServiceItem.serv;
            //     angular.forEach(servants, function (s) {
            //         if (servantid == s.id) {
            //             $ctrl.canReplaceTime = true;
            //         }
            //
            //     });
            // });

            vm.showReplaceTime = true;
        }

        function goToVideoCall(orderBagItem) {


            // $state.go('supplierPanel.joinVideoMeeting', {
            //     id: orderBagItem.id
            // });

            $mdDialog.show({
                controller: 'JoinVideoMeetingComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem
                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function deleteOrderBagItem(itemId) {
            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID')) {
                DialogService.showAlert("به دلیل صدور فاکتور امکان حذف وجود ندارد");
                return;
            } else {

                if (itemId != null) {
                    DialogService.showConfirmV2("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                        OrderBagCustom.deleteOrderBagItem().save(itemId, onDeleteItemSuccess, onDeleteItemError);

                    });
                }
            }
        }

        function onDeleteItemSuccess(result) {
            reload();
        }

        function onDeleteItemError() {

        }

        function settlementInvoice() {

            if (vm.orderBag.remainAmount == 0 || vm.orderBag.finalPrice == 0)
                return;

            var paymentLog = {};
            paymentLog.amount = vm.orderBag.remainAmount;
            paymentLog.paymentType = 'UNKNOWN';
            paymentLog.orderBagId = vm.orderBag.id;

            PaymentLogCustom.createPaymentLogByOrderBagId().save(paymentLog, onSettlementSaveSuccess, onSettlementSaveError);


        }

        function onSettlementSaveSuccess(result) {
            vm.invoiceInfo.paymentLogs.push({
                id: result.id,
                traceCode: result.traceCode,
                paymentType: result.paymentType,
                createDate: result.createDate,
                amount: result.amount,
            });

            vm.orderBag.remainAmount -= result.amount;
        }

        function onSettlementSaveError() {

        }

        function deletePaymentLog(paymentLog) {
            if(paymentLog.managerApprovalStatus === 'CHECKING' || paymentLog.managerApprovalStatus === 'DENIED' || paymentLog.managerApprovalStatus === 'APPROVED') return
            if (paymentLog != null) {
                if (paymentLog.paymentType == 'ONLINE')
                    return;

                DialogService.showConfirmV2("آیا از حذف آیتم اطمینان دارید ؟").then(function () {

                    PaymentLogCustom.deletePaymentLogById().delete({id: paymentLog.id},
                        function () {
                            reload();
                        });

                });
            }
        }

        function openMenu($mdOpenMenu, ev) {
            vm.originatorEv = ev;
            $mdOpenMenu(ev);
        }

        function checkOtherActions() {
            if (!vm.orderBag || !vm.orderBag.status)
                return;
            vm.showOtherActionsButton = true;

            switch (vm.orderBag.status) {

                case vm.constStatus.confirmed :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.canceled :
                    vm.canReApproveRequestToPay = true;
                    vm.canResendNotification = true;
                    break;
                case vm.constStatus.reserveRequest :
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = false;
                    vm.showOtherActionsButton = false;
                    break;
                case vm.constStatus.requestConfirm:
                    vm.canReApproveRequestToPay = false;
                    vm.canResendNotification = true;
                    break;
            }

            if (vm.orderBag.finalPrice == 0)
                vm.canReApproveRequestToPay = false;

        }


        function reConfirmReserveRequest() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("ادامه عملیات را تائید می فرمایید ؟").then(function () {
                    OrderBagCustom.reConfirmReserveRequestByOrderBagId().save(vm.orderBag.id, onReConfirmReserveSuccess, onReConfirmReserveError);

                });
            }
        }

        function onReConfirmReserveSuccess(result) {

            reload();
        }

        function onReConfirmReserveError() {

        }

        function reSendNotification() {
            if (vm.orderBag.id != null) {
                DialogService.showConfirmV2("ارسال مجدد پیام را تایید می فرمایید ؟").then(function () {
                    OrderBagCustom.reSendNotificationByOrderBagId().save(vm.orderBag.id, function (result) {
                        // reload();
                    });

                });
            }
        }

        function goToCustomerDetail() {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(vm.orderBag.customer.id).query().$promise.then(onGetSuccess);
                    }
                });
        }

        function onGetSuccess(result) {
            vm.companyCustomer = result;
            $state.go('supplierPanel-v2.editOrderBag.editCompanyCustomer', {id: vm.companyCustomer.id});

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if($rootScope.fromState.name === "supplierPanel-v2.editOrderBag.editCompanyCustomer") {
                 $state.go('supplierPanel-v2.reserveList');
            }
            else if($rootScope.fromState.name === "supplierPanel-v2.companyApprovalPaymentLogListV2") {
                $state.go($rootScope.fromState.name, $rootScope.fromStateParams)
            }else if($rootScope.fromState.name === "supplierPanel-v2.calendar-v2" || $rootScope.fromState.name === "supplierPanel-v2.calendar") {
                $state.go($rootScope.fromState.name, $rootScope.fromStateParams)
            }
            else
                $state.go('supplierPanel-v2.reserveList', $rootScope.fromStateParams);
        }


        vm.mainActions = function () {
            openBottomSheet('MAIN_ACTIONS');
        }
        vm.otherActions = function () {
            openBottomSheet('OTHER_ACTIONS');
        }

        vm.correctedTime = function (time) {
            //FUCK REGIME !!!!!!!!!!
            //Check Date - 6 month of the year
            var pDate = DateUtils.convertToPersianDate(time);
            time = new Date(time);
            if (pDate.getMonth() < 7) {
                time = new Date(time.setHours(time.getHours() - 1));
            }
            return time.toISOString();
        }

        function openBottomSheet(mode) {

            $mdBottomSheet.show({
                templateUrl: 'app/entities/order-bag/order-bag-bottom-sheet-template.html',
                controller: 'OrderBagBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: (function () {
                        return {
                            orderBag: vm.orderBag,
                            invoiceInfo: vm.invoiceInfo,
                            mode: mode,
                            constStatus: vm.constStatus,
                            resultStatus: vm.resultStatus,
                            canReApproveRequestToPay: vm.canReApproveRequestToPay,
                            canResendNotification: vm.canResendNotification,
                            canIssueInvoice: vm.hasInvoiceFeature,
                            showUseCredit: vm.orderBag.remainAmount > 0 && vm.canEditPaymentLog()
                        };
                    })


                },
            }).then(function (result) {
                switch (result) {
                    case 'approveOrderBag':
                        approveOrderBag();
                        break;
                    case 'confirmReserveRequest':
                        confirmReserveRequest();
                        break;
                    case 'cancelOrderBag':
                        cancelOrderBag();
                        break;
                    case 'settlementInvoice':
                        settlementInvoice();
                        break;
                    case 'insertPayment':
                        insertPayment();
                        break;
                    case 'reConfirmReserveRequest':
                        reConfirmReserveRequest();
                        break;
                    case 'reSendNotification':
                        reSendNotification();
                        break;
                    case 'deleteOrderBag':
                        deleteOrderBag();
                        break;
                    case 'issueInvoiceInfo':
                        issueInvoiceInfo();
                        break;
                    case 'viewInvoiceInfo':
                        viewInvoiceInfo();
                        break;
                    case 'useCredit':
                        showWithdrawFromWalletModal();
                        break;
                    case 'usePosPayment':
                        showPosPayment();
                        break;

                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }

        vm.openOrderBagItemBottomSheet = function (orderBagItem) {
            $mdBottomSheet.show({
                templateUrl: 'app/entities/order-bag/order-bag-item-bottom-sheet-template.html',
                controller: 'OrderBagItemBottomSheetController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem,
                            orderBag: vm.orderBag,
                            constStatus: vm.constStatus,
                            showReplaceTime: vm.showReplaceTime
                        };
                    })


                },
            }).then(function (result) {
                switch (result) {
                    case 'deleteOrderBagItem':
                        deleteOrderBagItem(orderBagItem.id);
                        break;
                    case 'replaceTime':
                        replaceTime(orderBagItem);
                        break;
                    case 'notCheckinOrderBagServieItem':
                        notCheckinOrderBagServieItem(orderBagItem.id);
                        break;
                    case 'checkinOrderBagServieItem':
                        checkinOrderBagServieItem(orderBagItem.id);
                        break;
                    case 'goToVideoCall':
                        goToVideoCall(orderBagItem);
                        break;

                }
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }
        

        function issueInvoiceInfo() {

            console.log(vm.hasInvoiceFeature);
            if (!vm.hasInvoiceFeature) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            OrderBagCustom.issueInvoiceInfoByOrderBagId().save(vm.orderBag.id, onIssueInvoiceSuccess, onIssueInvoiceError);

            function onIssueInvoiceSuccess(result) {

                $state.transitionTo('supplierPanel-v2.editInvoiceInfo', {id: result.id});
            }

            function onIssueInvoiceError(result) {

            }

        }

        function canEditPaymentLog(paymentLog) {


            if (vm.invoiceInfo.status && (vm.invoiceInfo.status == 'SETTLEMENT' || vm.invoiceInfo.status == 'VOID'))
                return false;

            if (paymentLog && paymentLog.paymentType == 'ONLINE')
                return false;

            return true;
        }

        function viewInvoiceInfo() {
            if (vm.invoiceInfo.status && vm.invoiceInfo.status == 'TEMP')
                $state.transitionTo('supplierPanel-v2.editInvoiceInfo', {id: vm.invoiceInfo.id});
            else
                $state.transitionTo('supplierPanel-v2.invoiceInfoDetail', {id: vm.invoiceInfo.id});
        }

        $scope.calcManagerApprovalStatus = function(status) {
             switch(status) {
                case 'APPROVED': return 'تایید شده';
                case 'DENIED': return 'رد شده';
                case 'CHECKING': return 'درحال بررسی';
                default: return '';
            }
        };
        $scope.getStatusClass = function(status) {
            switch(status) {
                case 'APPROVED': return 'status-approved';
                case 'DENIED': return 'status-denied';
                case 'CHECKING': return 'status-chicking';
                default: return 'status-unknown';
            }
        };
        $scope.getDynamicStyleRemoveIcon = function(paymentLog) {
            var color = "red";
            if(paymentLog.managerApprovalStatus === 'CHECKING' || paymentLog.managerApprovalStatus === 'DENIED' || paymentLog.managerApprovalStatus === 'APPROVED' || paymentLog.onlineGateway === 'WALLET_CUSTOMER_WEB')
                color = 'unset';
            
            if(!vm.canEditPaymentLog(paymentLog))
                color = "unset";
            return {
                color: color
            };
        };

        function showWithdrawFromWalletModal() {
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/wallet/wallet-withdraw-balance-dialog.html',
                controller: ['$scope', 'customerId', 'withdrawAmount', 'orderBagId', function ($scope, customerId, withdrawAmount, orderBagId) {
                    $scope.customerId = customerId;
                    $scope.withdrawAmount = withdrawAmount;
                    $scope.orderBagId = orderBagId;
                }],
                locals: {
                    customerId: vm.orderBag.customer.id,
                    withdrawAmount: vm.orderBag.remainAmount,
                    orderBagId: vm.orderBag.id
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(function (res) {
                if (res) {
                    reload()
                    // onSettlementSaveSuccess(res)
                }
            });
        }

        function showPosPayment(){
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/pos-payment/pos-payment-dialog.html',
                controller: ['$scope', 'customerId', 'totalAmount', 'invoiceInfoId', 'posDeviceId', function ($scope, customerId, totalAmount, invoiceInfoId, posDeviceId) {
                    $scope.customerId = customerId;
                    $scope.totalAmount = totalAmount;
                    $scope.invoiceInfoId = invoiceInfoId;
                    $scope.posDeviceId = posDeviceId
                }],
                locals: {
                    customerId: vm.orderBag.customer.id,
                    totalAmount: vm.orderBag.remainAmount,
                    invoiceInfoId: vm.invoiceInfo.id,
                    posDeviceId: 123456
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(function (res) {
                if (res) {
                    reload()
                    // onSettlementSaveSuccess(res)
                }
            });
        }

    }
})();
